// Owner: P1 piece 3 "Omnibar and search" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): keep the one export `feature` and its type; fill
// `app`/`bare` and `nav`. Paths: none; the palette mounts through `mount.tsx`.
import type { Feature } from '../feature.ts'

export const feature: Feature = { nav: [] }
